'use client';

import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';
export var DataDog = function DataDog(_ref) {
  var config = _ref.config;
  useEffect(function () {
    var _window, _window$_infl, _window$_infl$api;

    var currentOrigin = window.location.origin;
    var url = new URL(currentOrigin);
    var domain = url.hostname.split('.').slice(-2).join('.');
    var apiOrigin = "https://api.".concat(domain);

    if ((_window = window) !== null && _window !== void 0 && (_window$_infl = _window._infl) !== null && _window$_infl !== void 0 && (_window$_infl$api = _window$_infl.api) !== null && _window$_infl$api !== void 0 && _window$_infl$api.url) {
      apiOrigin = window._infl.api.url;
    }

    datadogRum.init(_objectSpread({
      site: 'datadoghq.com',
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      trackFrustrations: true,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      useSecureSessionCookie: true,
      useCrossSiteSessionCookie: true,
      allowedTracingUrls: [currentOrigin, function (url) {
        return url.startsWith(currentOrigin);
      }, apiOrigin, function (url) {
        return url.startsWith(apiOrigin);
      }],
      traceSampleRate: 100
    }, config));
    datadogRum.startSessionReplayRecording();
    return function () {
      datadogRum.stopSessionReplayRecording();
    };
  }, []);
  return null;
};